import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";

import { useTranslation } from "../../../shared/language";

type DialogRegisteredAssetInvoiceWarningProps = {
  visible: boolean;
  onHide: () => void;
  onReplace: () => void;
  onContinueAdjustment: () => void;
};

/**
 * Hiển thị cảnh báo nghiệp vụ trước khi mở luồng điều chỉnh hóa đơn mẫu 01/BTS.
 */
export const DialogRegisteredAssetInvoiceWarning = ({
  visible,
  onHide,
  onReplace,
  onContinueAdjustment,
}: DialogRegisteredAssetInvoiceWarningProps) => {
  const { t } = useTranslation();

  const footer = (
    <div className="flex justify-content-end gap-2">
      <Button
        type="button"
        label={t("common.continueAdjustment")}
        className="p-button-outlined p-button-sm"
        onClick={onContinueAdjustment}
      />
      <Button
        type="button"
        label={t("common.replaceInvoice")}
        className="p-button-sm"
        onClick={onReplace}
      />
    </div>
  );

  return (
    <Dialog
      visible={visible}
      onHide={onHide}
      header={t("common.warning")}
      footer={footer}
      modal
      closable
      draggable={false}
      resizable={false}
      style={{ width: "min(45rem, 92vw)" }}
    >
      <div className="line-height-3 text-900">
        {t("common.registeredAssetInvoiceAdjustmentWarning")}
      </div>
    </Dialog>
  );
};
